<div id="header">
  <a class="logo" [routerLink]="homePageRoute">
    @if (authService.isAuthenticated()) {
      <img alt="Logo" src="assets/img/logo/{{ authService.organization.logo }}" />
    }
    @if (!authService.isAuthenticated()) {
      <img alt="Logo" src="assets/img/logo/{{ environmentService.logo }}" />
    }
  </a>

  <div class="section main-text">
    <div class="heading" [title]="headerService.centerContentText | async">
      {{ headerService.centerContentText | async }}
      @if (isManuallyAddedPatient && authService.isEntitled('/patients/updateManualPatientPrivileged')) {
        <button
          type="button"
          class="btn btn-link btn-sm p-0 ms-2"
          (click)="openUpdateMemberModal(contentUpdateMember)"
          title="Update Member Information"
        >
          <i class="fas fa-edit"></i>
        </button>
      }
    </div>
    @if (memberId) {
      <div class="subheading">Pronouns: {{ headerService.pronounText | async }}</div>
    }
  </div>

  @if (authService.isAuthenticatedAndAgreed() && authService.linkedOrganizations?.length) {
    <div class="section select-org">
      <div ngbDropdown class="dropdown">
        <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" ngbDropdownToggle>
          <i class="far fa-building me-2"></i>
          <span class="me-1">{{ authService.organization.orgName }}</span>
        </button>
        <div class="dropdown-menu" ngbDropdownMenu>
          @for (organization of authService.linkedOrganizations; track organization) {
            <button
              type="button"
              (click)="switchOrganization(organization)"
              class="dropdown-item btn-sm"
              ngbDropdownItem
            >
              {{ organization.orgName }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (authService.isAuthenticatedAndAgreed() && authService.isEntitled('/header/composeMessage.html')) {
    <div class="section messenger">
      <button
        id="appHeaderSendMessageModal"
        type="button"
        class="btn btn-outline-primary btn-sm circular"
        (click)="sendNewMessage(sendMessage)"
      >
        <i class="fas fa-paper-plane fa-fw" aria-hidden="true"></i>
      </button>
    </div>
  }

  @if (!authService.isAuthenticated()) {
    <div class="section support">
      <button type="button" class="btn btn-outline-primary btn-sm circular" [ngbPopover]="supportPopover">
        <i class="fas fa-question fa-fw" aria-hidden="true"></i>
      </button>
      <ng-template #supportPopover>
        <div [innerHTML]="supportInformation"></div>
      </ng-template>
    </div>
  }

  @if (authService.isAuthenticatedAndAgreed() && authService.isEntitled('/patients/viewPatients.html')) {
    <form class="section quick-search">
      <input
        id="header-quick-search"
        type="text"
        class="form-control"
        [class.quick-search-results]="!showingRecentlyViewed"
        [class.quick-search-recently-viewed]="showingRecentlyViewed"
        [class.loading]="searchingMemberList || searching"
        popupClass="unlimited-height"
        placeholder="Enter member ID or name"
        name="quickSearch"
        [(ngModel)]="searchValue"
        [ngbTypeahead]="searchMemberList"
        (keyup.enter)="fetchMemberId()"
        [inputFormatter]="formatSearchInput"
        (selectItem)="onSelectMember($event)"
        [resultTemplate]="searchResultTemplate"
        (focus)="searchInputFocus$.next($event.target.value)"
      />
      <ng-template #searchResultTemplate let-r="result" let-t="term">
        <ngb-highlight [result]="formatMemberQuickSearch(r)" [term]="t"></ngb-highlight>
      </ng-template>
    </form>
  }
</div>

<ng-template #sendMessage let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Care Messenger</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <th-create-new-message></th-create-new-message>
  </div>
</ng-template>

<ng-template #contentUpdateMember let-modal>
  <th-update-manual-patient-info [memberId]="memberId" [patientDetails]="patient"></th-update-manual-patient-info>
</ng-template>
